import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-cambio-exitoso-modal',
  templateUrl: './cambio-exitoso-modal.component.html',
  styleUrls: ['./cambio-exitoso-modal.component.css']
})
export class CambioExitosoModalComponent {
  constructor(public dialogRef: MatDialogRef<CambioExitosoModalComponent>) { }

  ingresar(): void {
    this.dialogRef.close();
  }
}
